import React from 'react';
import AuthHeader from './components/AuthHeader';
import AuthForm from './components/AuthForm';
import AuthBackground from './components/AuthBackground';
import AuthFooter from './components/AuthFooter';

const Authentication = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <AuthHeader />
      
      {/* Main Content */}
      <main className="flex-1 flex">
        {/* Left Side - Form */}
        <div className="flex-1 lg:w-1/2 flex flex-col justify-center px-6 py-24 lg:px-12">
          <AuthForm />
        </div>

        {/* Right Side - Background */}
        <AuthBackground />
      </main>

      <AuthFooter />
    </div>
  );
};

export default Authentication;